import { render, staticRenderFns } from "./index.vue?vue&type=template&id=42d7846a&scoped=true&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&id=42d7846a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d7846a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('42d7846a')) {
      api.createRecord('42d7846a', component.options)
    } else {
      api.reload('42d7846a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=42d7846a&scoped=true&", function () {
      api.rerender('42d7846a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/settings/index.vue"
export default component.exports